import { Zap } from "lucide-react";

export function Loading({ label = "Loading" }) {
  return (
    <div className="flex items-center justify-center py-24" data-testid="loading-state">
      <div className="flex flex-col items-center gap-3">
        <Zap className="text-cyan-400 hw-pulse" size={30} />
        <span className="hw-eyebrow">{label}…</span>
      </div>
    </div>
  );
}

export function EmptyState({ title, subtitle, icon: Icon }) {
  return (
    <div className="hw-card p-12 text-center" data-testid="empty-state">
      {Icon && <Icon className="mx-auto mb-4 text-slate-600" size={40} />}
      <h3 className="font-head text-2xl font-bold text-slate-200">{title}</h3>
      {subtitle && <p className="mt-2 text-slate-400">{subtitle}</p>}
    </div>
  );
}
